import contextMenu from './context-menu'
import form from './form'
import handler from './handler'

export default {
    contextMenu,
    form,
    handler
}
